import type { ReactNode } from 'react';
import { BekebiMark } from './brand';

/** Centered page used by the few screens outside the portal shell (not found, session check). */
export function PageFrame({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-canvas">
      <div className="flex items-center gap-2.5 px-6 py-5 sm:px-8">
        <BekebiMark size={30} />
        <span className="text-base font-semibold tracking-tight text-fg">Bekebi Portal</span>
      </div>
      <main className="mx-auto w-full max-w-3xl px-4 py-10 sm:px-6">{children}</main>
    </div>
  );
}
